import {Button, Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import {useEffect, useState} from "react";
import {FieldGrid} from "./grid";
import {FieldForm} from "./form";
import {getFields} from "../../../services/field/field";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import {PaginateContext} from "../../../context/paginate";

export function FieldManagement() {

  const [fields, setFields] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getFields(paginate);
    if (result.status === 200) {
      const {fieldList, total_count} = result.data;
      setFields(fieldList || []);
      setGridTotalRowCount(total_count);
    }
  }

  useEffect(() => {
    // const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [gridCurrentPage, gridRowCount, sortBy, sortType, lastDataRefresh]);

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="">
        <FieldForm field={gridSelectedRow} open={modalOpen} setOpen={setModalOpen}
                   setLastDataRefresh={setLastDataRefresh} setGridSelectedRow={setGridSelectedRow}/>
        <Card className="pt-8">
          <CardHeader floated={true} shadow={false} className="rounded-none">
            <div className="mb-8 flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">رشته‌مباشر</Typography>
              <Button onClick={() => {
                setGridSelectedRow(null);
                setModalOpen(true);
              }} variant="outlined">جدید</Button>
            </div>
          </CardHeader>
          <CardBody className="overflow-x-auto w-full">
            <FieldGrid
              fields={fields}
              setModalOpen={setModalOpen}
              setSelectedRow={setGridSelectedRow}
            />
          </CardBody>
          <CardFooterPaginator/>
        </Card>
      </div>
    </PaginateContext.Provider>
  );
}